import { render, staticRenderFns } from "./NewsInDetail.vue?vue&type=template&id=1f4e6732&scoped=true&"
import script from "./NewsInDetail.vue?vue&type=script&lang=js&"
export * from "./NewsInDetail.vue?vue&type=script&lang=js&"
import style0 from "./NewsInDetail.vue?vue&type=style&index=0&id=1f4e6732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4e6732",
  null
  
)

export default component.exports